module.exports = __webpack_public_path__ + "static/img/龙头启动.8084f97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/龙头启动.png
// module id = W6l4
// module chunks = 1